import { UndoOutlined } from "@ant-design/icons";
import { Button, Col, Row } from "antd";
import type React from "react";
import { useAudienceModalContext } from "../../providers/AudienceModalContext";

export interface AudienceModalHeaderProps {
	onClear?: () => void;
	showClearButton?: boolean;
}

const AudienceModalHeader: React.FC<AudienceModalHeaderProps> = ({
	onClear,
	showClearButton = true,
}) => {
	const { searchForm, step } = useAudienceModalContext();

	const handleClear = () => {
		if (onClear) {
			onClear();
		} else {
			searchForm?.resetFields();
		}
	};

	// Only show header in search step
	if (step !== "search" || !showClearButton) {
		return null;
	}

	return (
		<Row>
			<Col xs={24} className="mb-4">
				<div className="flex justify-end">
					<Button type="dashed" icon={<UndoOutlined />} onClick={handleClear}>
						フィルタークリア
					</Button>
				</div>
			</Col>
		</Row>
	);
};

export default AudienceModalHeader;
